import { routeCreator } from '@adrias-online/steiner';
import _ from 'lodash';

import helper from 'helpers/steinerHelper';
import routeRegister from 'helpers/routeRegister';
import { selectors } from '../reducers/hotelInterazioni';

const routes = helper.generateRoutes('hotelInterazioni', selectors);
const list = _.values(routes.list).map(route => ({
    ...route,
    getComponent() {
        return new Promise(resolve => {
            import(/* webpackChunkName: 'hotelInterazioni' */ `modules/hotelInterazioni/${route.componentPath}`)
                .then(response => resolve(response.default));
        });
    },
}));

const links = routeCreator.generateLinks(routes.patterns);

routeRegister.addPatterns('hotelInterazioni', routes.patterns);
routeRegister.addLinks('hotelInterazioni', links);

export default list;